export class FeedbackMessageAttachment {
  constructor({ extension, name, size } = {}) {
    this.extension = extension;
    this.name = name;
    this.size = size;
  }
}
